/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrendingUndergroundNotificationActionData } from './TrendingUndergroundNotificationActionData';
import {
    TrendingUndergroundNotificationActionDataFromJSON,
    TrendingUndergroundNotificationActionDataFromJSONTyped,
    TrendingUndergroundNotificationActionDataToJSON,
} from './TrendingUndergroundNotificationActionData';

/**
 * 
 * @export
 * @interface TrendingUndergroundNotificationAction
 */
export interface TrendingUndergroundNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof TrendingUndergroundNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof TrendingUndergroundNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof TrendingUndergroundNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {TrendingUndergroundNotificationActionData}
     * @memberof TrendingUndergroundNotificationAction
     */
    data: TrendingUndergroundNotificationActionData;
}

/**
 * Check if a given object implements the TrendingUndergroundNotificationAction interface.
 */
export function instanceOfTrendingUndergroundNotificationAction(value: object): value is TrendingUndergroundNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function TrendingUndergroundNotificationActionFromJSON(json: any): TrendingUndergroundNotificationAction {
    return TrendingUndergroundNotificationActionFromJSONTyped(json, false);
}

export function TrendingUndergroundNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrendingUndergroundNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': TrendingUndergroundNotificationActionDataFromJSON(json['data']),
    };
}

export function TrendingUndergroundNotificationActionToJSON(value?: TrendingUndergroundNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': TrendingUndergroundNotificationActionDataToJSON(value.data),
    };
}

